import { FieldDef } from '@core/models';
import { RelatedToType } from '@shared/enums';

export interface PropertyPagination {
  length: number;
  size: number;
  page: number;
  lastPage: number;
  startIndex: number;
  endIndex: number;
}

// [SC-49194]: Property mapped fields to trigger regeocode update confirmation dialog.
export const FIELDS_TO_REGEOCODE = [
  'city',
  'state',
  'postal_code',
  'street_address',
  'address_string',
  'latitude',
  'longitude',
];

export const PROPERTY_ADD_FORM_FIELDS_BLACKLIST = ['project_ids', 'title', 'latitude', 'longitude'];

export function getCustomAddressWithCoordinatesFieldDef(
  relatedToType: RelatedToType,
): Omit<
  FieldDef,
  | 'account_id'
  | 'created_at'
  | 'created_by_id'
  | 'created_by_user_name'
  | 'custom_object_id'
  | 'import'
  | 'locked'
  | 'meta'
  | 'related_to_id'
  | 'displayGroupedType'
  | 'val'
  | 'required_for_import'
  | 'usedForTimeSeries'
  | '_parentFieldName'
  | '_parentFieldLabel'
  | '_parentFieldMeta'
  | 'task_role_id'
  | 'tsTableOptions'
  | 'conditional_styling'
> {
  return {
    name: 'cff_address',
    label: 'Custom Address with Coordinates',
    type: 'text',
    related_to_type: relatedToType,
    isRemovable: relatedToType === RelatedToType.Property ? false : true,
    isRequired: relatedToType === RelatedToType.Property ? true : false,
  };
}
